import MappingDropdown from '../components/MappingDropdown'
import { connect } from 'react-redux'
import { setContextByKey, removeContext, setVocabularyType } from '../util/actions'

const mapStateToProps = (state) => ({
  vocabularies: state.mapping.vocabularies,
  selectedContext: state.mapping.selectedContext,
  vocabularyType: state.mapping.vocabularyType
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  setProperty: (keyName, property) => {
    if (keyName) {
      dispatch(setContextByKey(keyName, property))
    }
  },
  removeProperty: (keyName) => {
    dispatch(removeContext(keyName))
  },
  setItemType: (keyName, property, type) => {
    dispatch(setContextByKey(keyName, property, type))
  },
  handleChangeType: (props, type) => {
    dispatch(setVocabularyType(props.keyName, type))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(MappingDropdown)


// WEBPACK FOOTER //
// ./src/containers/MappingDropdown.js